<template>
	<div class="c-modal-folder-update">
		<Modal v-model="options.active" @input="closeModal" :closable="true">
			<template v-slot:title>
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M2 10.5H22M22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H7.79844C8.25258 4 8.6932 4.15456 9.04783 4.43826L10.4522 5.56174C10.8068 5.84544 11.2474 6 11.7016 6H19C20.6569 6 22 7.34315 22 9Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-width="1.5"
					/>
				</svg>

				<h3>Update folder</h3>
			</template>
			<template>
				<FormFolderUpdate
					v-if="forceRender"
					:folder="folder"
					@onSubmit="onSubmit"
				></FormFolderUpdate>
			</template>
			<template v-slot:footer>
				<div class="c-modal-folder-update__meta" v-if="createdByUser">
					<article>
						<span> Created by: </span>
						<p>
							<img :src="`${assetUrl}/${createdByUser.avatar.name}`" />{{
								createdByUser.name
							}}
						</p>
					</article>
					<article v-if="folder.createdAt">
						<span> Created on: </span>
						<p>{{ formatDate(folder.createdAt) }}</p>
					</article>
				</div>
				<small v-if="folder && folder.hidden">
					This folder is marked as hidden. Only the user who created this folder
					OR the admin user can update this folder and view all boards inside
					this folder.
				</small>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from './index.vue';
import { parseISO, format } from 'date-fns';
import FormFolderUpdate from '../form/form-folder-update';

export default {
	components: {
		Modal,
		FormFolderUpdate,
	},

	data: function () {
		return {
			options: {
				name: 'modal-folder-update',
				active: false,
			},
			forceRender: true,
		};
	},

	props: {
		selection: {},
	},

	watch: {
		'options.active': {
			handler: function () {},
		},
		editId: function () {
			if (this.editId) {
				this.options.active = true;
			} else {
				this.options.active = false;
			}
		},
		folder: function () {
			this.forceRender = false;
			this.$nextTick(() => {
				this.forceRender = true;
			});
		},
	},

	computed: {
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		createdByUser: function () {
			if (!this.folder) {
				return;
			}
			const userId = this.folder.userId;

			let u = null;

			for (let i = 0; i < this.workspace.users.length; i++) {
				const user = this.workspace.users[i];

				if (user.id === userId) {
					u = user;
					break;
				}
			}

			return u;
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
		editId: function () {
			return this.$store.getters['folders/editId'];
		},
		folder: function () {
			if (!this.editId) {
				return;
			}
			let folders = this.$store.getters['folders/filtered'];

			let folder = null;

			for (let i = 0; i < folders.length; i++) {
				const f = folders[i];
				if (f.id === this.editId) {
					folder = f;
					break;
				}
			}

			return folder;
		},
	},

	methods: {
		formatDate: function (isoDate) {
			let date = parseISO(isoDate);
			let str = format(date, 'do MMM yyyy');

			return str;
		},
		onSubmit: function () {},
		activate: function () {
			this.options.active = true;
		},
		closeModal: function () {
			this.$store.dispatch('folders/setEdit', null);
			//this.options.active = false;
		},
		afterDelete: function () {
			this.closeModal();
		},
	},

	mounted: function () {},
};
</script>

<style lang="scss">
.c-modal-folder-update {
	.vfm__overlay {
		&.non-closable {
		}
	}
	.modal-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		overflow-y: auto;
		padding: 0;
	}

	.modal-content {
	}

	.form-edit-boards {
		align-self: baseline;
	}

	.modal-content {
		overflow: hidden;
	}

	.modal {
		&__title {
			display: flex;
			align-items: center;
			padding: 16px var(--spacer);
			background-color: var(--color-bg-2);
			border-bottom: var(--color-bg-4) solid 1px;

			svg {
				width: 32px;
				height: 32px;
				margin-right: var(--margin-lg);
			}

			h3 {
				margin-bottom: 0;
			}
		}

		&__content {
			padding-top: var(--spacer-sm);
			padding-bottom: var(--spacer-sm);
			background-color: var(--color-bg-1);
		}

		&__footer {
			padding: 16px var(--spacer);
			background-color: var(--color-bg-2);
			border-top: var(--color-bg-4) solid 1px;
		}
	}

	&__meta {
		font-size: var(--font-size-sm);

		article {
			display: grid;
			grid-template-columns: 94px 1fr;
			align-items: center;
			min-height: 24px;
			padding: var(--margin-sm) 0;
		}

		span {
			opacity: 0.75;
		}
		p {
			display: flex;
			align-items: center;
			margin: 0;
		}
		img {
			display: inline-block;
			width: 24px;
			height: 24px;
			border-radius: 99px;
			object-fit: cover;
			margin-right: var(--margin);
		}
	}
}
</style>
